import type { ReadonlyDate } from '../../utils'

export type CSVData = readonly (readonly (string | number | ReadonlyDate | null)[])[]

export interface FileService {
    /**
     * Downloads the given file
     */
    download(file: File): void

    /**
     * Generate CSV file
     * @param fileName - without file extension (.csv)
     * @param head - header
     * @param data - body
     */
    generateCSV(fileName: string, head: readonly string[], data: CSVData): File
}
